export default "__VITE_ASSET__BXqJngvH__"